import React from "react";
import EventForm from "../../components/events/EventForm";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useEvents } from "../../services/admin/EventsServices";

export default function AddEventPage() {
    const navigate = useNavigate();
    const { createEvent, loading } = useEvents();

    const handlePublish = async (data) => {
        const result = await createEvent(data);
        if (result && result.status === "success") {
            navigate("/admin/events");
        }
    };

    return (
        <>
            <div className="p-6 lg:p-10 max-w-5xl mx-auto">
                {/* Navigation Header */}
                <button
                    onClick={() => navigate("/admin/events")}
                    className="flex items-center gap-2 text-black dark:text-white/40 hover:text-black/70 dark:hover:text-white transition-colors text-xs font-bold tracking-widest uppercase mb-6"
                >
                    <ChevronLeft size={16} /> BACK TO EVENTS
                </button>

                <div className="mb-10">
                    <h1 className="text-3xl lg:text-4xl font-normal text-black dark:text-white mb-2" style={{ fontFamily: "Playfair Display, serif" }}>
                        Schedule New Event
                    </h1>
                    <p className="text-black dark:text-white/50 text-sm italic font-serif">
                        Enter the performance details to update your tour schedule.
                    </p>
                </div>

                {/* Form */}
                <EventForm onSubmit={handlePublish} isLoading={loading} />
            </div>
        </>
    );
}
